export default __webpack_public_path__ + "static/media/sagarImage.e6387fa0.jpeg";